import { makeAutoObservable } from 'mobx';
import { CampaignModel } from './CampaignModel';
import { CampaignModelType, SingleCampaignStore } from './SingleCampaign.store';
import { Common } from 'src/AppState/Common';
import { BonusStatusType, BonusWinningsWalletViewType } from 'src/api_openapi/v2/bonus-engine/schemas';
import { Amount } from 'src_common/common/amount/Amount';
import { BonusBalanceProgressModel } from './BonusBalanceProgressModel';
import { BonusBalanceProgressStore } from './BonusBalanceProgress.store';

export class BonusWinningsModel {
    public constructor(
        private readonly common: Common,
        private readonly accountId: number,
        private readonly data: BonusWinningsWalletViewType
    ) {
        makeAutoObservable(this);
    }

    public get id(): string {
        return this.data.bonusId;
    }

    public get status(): BonusStatusType {
        return this.data.status;
    }

    public get balance(): Amount {
        return new Amount(this.data.balance.toString());
    }

    public get rewardName(): string | null {
        return this.data.rewardName ?? null;
    }

    public get isBlocked(): boolean {
        return this.data.isBlocked;
    }

    public get playthrough(): number | null {
        return this.data.playthrough ?? null;
    }

    public get campaignModel(): CampaignModelType | 'loading' | null {
        if (this.data.campaignId === undefined || this.data.campaignId === null) {
            return null;
        }

        return SingleCampaignStore.get(this.common, this.data.campaignId).campaignModel;
    }

    public get campaignModelWhenReady(): CampaignModel | null {
        if (this.data.campaignId === undefined || this.data.campaignId === null) {
            return null;
        }

        const result = SingleCampaignStore.get(this.common, this.data.campaignId).campaignModel;

        if (result === 'loading' || result.status === 'error') {
            return null;
        }

        return result.body;
    }

    public get bonusBalanceProgressModel(): BonusBalanceProgressModel | 'loading' | 'error' | null {
        return BonusBalanceProgressStore.get(this.common, this.accountId, this.data.bonusId).bonusBalanceProgressModel;
    }

    public get bonusBalanceProgressModelWhenReady(): BonusBalanceProgressModel | null {
        const result = BonusBalanceProgressStore.get(
            this.common,
            this.accountId,
            this.data.bonusId
        ).bonusBalanceProgressModel;

        if (result === 'loading' || result === 'error') {
            return null;
        }
        return result;
    }
}
